import { render, staticRenderFns } from "./AuthError.vue?vue&type=template&id=00200968&scoped=true"
import script from "./AuthError.vue?vue&type=script&lang=js"
export * from "./AuthError.vue?vue&type=script&lang=js"
import style0 from "./AuthError.vue?vue&type=style&index=0&id=00200968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00200968",
  null
  
)

export default component.exports